import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={25}
    height={23}
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25 18.2708H0V0.5625H25V18.2708ZM1.04175 17.2291H23.9587V1.60381H1.04175V17.2291Z"
      fill={color}
    />
    <path d="M5.76172 21.3945H18.3362V22.4362H5.76172V21.3945Z" fill={color} />
    <path
      d="M9.21198 12.1406L6.22932 9.09809L3.28974 11.7785L2.58789 11.009L6.27013 7.65154L9.20632 10.6469L16.3762 3.21875L19.2623 8.78537L21.652 8.61591L21.7258 9.65515L18.6529 9.87278L16.1189 4.98566L9.21198 12.1406Z"
      fill={color}
    />
    <path d="M15.625 18.0117H16.6667V21.918H15.625V18.0117Z" fill={color} />
    <path d="M7.8125 18.0117H8.8542V21.918H7.8125V18.0117Z" fill={color} />
    <path d="M20.834 10.9785H21.8757V16.1157H20.834V10.9785Z" fill={color} />
    <path d="M18.2295 10.9785H19.2712V16.1157H18.2295V10.9785Z" fill={color} />
    <path d="M12.5 10.9785H13.5417V16.1157H12.5V10.9785Z" fill={color} />
    <path d="M15.625 6.8125H16.6667V16.1166H15.625V6.8125Z" fill={color} />
    <path d="M8.85449 13.0625H9.89619V16.1164H8.85449V13.0625Z" fill={color} />
    <path d="M5.72949 10.9785H6.77119V16.1157H5.72949V10.9785Z" fill={color} />
    <path d="M2.60449 12.543H3.64619V16.1177H2.60449V12.543Z" fill={color} />
  </svg>
);
export default SVGComponent;